/* eslint import/prefer-default-export: 0 */
import axios from '../utils/api'

import CONFIG from '../config'
import { isCachedItem, isCachedCollection } from '../utils/caching'

import {
  SAVE_TIMESERIES_REQUEST, SAVE_TIMESERIES_RESPONSE, SAVE_TIMESERIES_RESPONSE_ERROR,
  FETCH_TIMESERIES_REQUEST, FETCH_TIMESERIES_RESPONSE, FETCH_TIMESERIES_RESPONSE_ERROR,
  LIST_UNIT_TIMESERIES_REQUEST, LIST_UNIT_TIMESERIES_RESPONSE,
  LIST_TIMESERIES_TYPES_REQUEST, LIST_TIMESERIES_TYPES_RESPONSE,
} from '../constants'

export function listTimeseriesTypes() {
  return (dispatch, getState) => {
    if (isCachedCollection(getState().timeseriesTypes)) {
      return
    }

    dispatch({ type: LIST_TIMESERIES_TYPES_REQUEST })

    axios.get(`${CONFIG.apiBase}/timeseries_types`).then((response) => {
      dispatch({
        type: LIST_TIMESERIES_TYPES_RESPONSE,
        timeseriesTypes: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}

export function addUnitTimeseries(unitId, deviceId, sensorId, timeseriesName) {
  return (dispatch) => {
    const timeseries = {
      device_id: deviceId,
      sensor_id: sensorId,
      unit_id: unitId,
      name: timeseriesName,
    }
    dispatch({ type: SAVE_TIMESERIES_REQUEST, timeseries })
    axios.post(`${CONFIG.apiBase}/timeseries`, timeseries).then((response) => {
      dispatch({
        type: SAVE_TIMESERIES_RESPONSE,
        timeseries: response.data.body,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: SAVE_TIMESERIES_RESPONSE_ERROR,
        error,
        timeseries: {
          id: timeseries.id,
        },
      })
    })
  }
}

export function saveTimeseries(timeseries) {
  return (dispatch) => {
    dispatch({ type: SAVE_TIMESERIES_REQUEST, timeseries })
    axios.put(`${CONFIG.apiBase}/timeseries/${timeseries.id}`, timeseries).then((response) => {
      dispatch({
        type: SAVE_TIMESERIES_RESPONSE,
        timeseries: response.data.body,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: SAVE_TIMESERIES_RESPONSE_ERROR,
        error,
        timeseries: {
          id: timeseries.id,
        },
      })
    })
  }
}

export function saveUnitTimeseries(timeseriesId, deviceId, sensorId) {
  const timeseries = {
    id: timeseriesId,
    device_id: deviceId,
    sensor_id: sensorId,
  }
  return saveTimeseries(timeseries)
}

export function fetchTimeseries(id) {
  return (dispatch, getState) => {
    if (isCachedItem(getState().timeseries, id)) {
      return
    }
    dispatch({ type: FETCH_TIMESERIES_REQUEST, id })
    axios.get(`${CONFIG.apiBase}/timeseries/${id}`).then((response) => {
      dispatch({
        type: FETCH_TIMESERIES_RESPONSE,
        id,
        timeseries: response.data.body,
      })
    }).catch((error) => {
      // TODO: error handling
      // console.log(error);
      dispatch({
        type: FETCH_TIMESERIES_RESPONSE_ERROR,
        error,
        id,
        timeseries: {
          id,
        },
      })
    })
  }
}

export function listUnitTimeseries(unitId) {
  function getLoaderId(action) {
    return action.unitId
  }

  return (dispatch, getState) => {
    if (isCachedItem(getState().timeseriesByUnit, unitId)) {
      return
    }
    dispatch({
      type: LIST_UNIT_TIMESERIES_REQUEST,
      unitId,
      getLoaderId,
    })
    axios.get(`${CONFIG.apiBase}/units/${unitId}/timeseries`).then((response) => {
      dispatch({
        type: LIST_UNIT_TIMESERIES_RESPONSE,
        unitId,
        getLoaderId,
        timeseries: response.data.body,
      })
    }).catch((/* error */) => {
      // TODO: error handling
      // console.log(error);
    })
  }
}
